import {computed, ComputedRef, Ref, ref} from "vue";
import {CoursePlanVO, CourseVO, fetchUserCourse} from "@/apis/course";

export default function useCourseSchedule(): {
  courseVO: Ref<CourseVO | undefined>,
  plans: ComputedRef<CoursePlanVO[]>,
  getCourseSchedule: (courseId: number) => Promise<void>
} {
  const courseVO = ref<CourseVO>()

  const getCourseSchedule = async (courseId: number) => {
    const data = await fetchUserCourse(courseId)
    courseVO.value = data?.data
    document.title = courseVO.value?.courseName || '贪心科技'
  }

  const plans: ComputedRef<CoursePlanVO[]> = computed(() => courseVO.value?.plans || [])

  return {
    courseVO,
    plans,
    getCourseSchedule
  }
}
